/* SessionStatusBadge.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4c065UPgdg%7Bpadding-block%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Y7lL4FQfX%7Bpadding-inline%3Avar(--ds-space-025%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2V7sgONvrM%7Bborder-width%3Avar(--ds-border-width%2C1px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3hxITi6wH8%7Bborder-style%3Asolid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbccYA%7Bdisplay%3Ainline-flex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1EqgXlN91d%7Bmax-width%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIdnbC%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39HuIbz8Lp%7Btext-overflow%3Aellipsis%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3vBAKHJrlu%7Bborder-color%3Avar(--ds-border-brand%2C%231868db)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0KLXrunl7T%7Bbackground-color%3Avar(--ds-background-brand-subtlest%2C%23e9f2fe)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1UtDYzGaer%7Bcolor%3Avar(--ds-text-brand%2C%231868db)%7D");
import React from 'react';
import { type MessageDescriptor, useIntl } from 'react-intl';
import { cx } from '@atlaskit/css';
import { Box, Inline, Text } from '@atlaskit/primitives/compiled';
import { messages } from './messages';
import { SessionStatusIcon, type SessionStatus, type SessionStatusIconSize } from './SessionStatusIcon';
type SessionStatusBadgeStatus = SessionStatus;
type SessionStatusBadgeProps = {
  status: SessionStatusBadgeStatus;
  /** Visual size for the needs-input icon. Defaults to 12. */
  iconSize?: SessionStatusIconSize;
  testId?: string;
  ariaLabel?: string;
};
const styles = {
  badge: "_0bjKvDKxmn _4c065UPgdg _2Y7lL4FQfX _2V7sgONvrM _3hxITi6wH8 _3iDTPbccYA _24h04i2Njc _1EqgXlN91d _1ANEUSLRg7",
  label: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _39HuIbz8Lp"
};
const statusStyles = {
  'needs-input': "_3vBAKHJrlu _0KLXrunl7T _1UtDYzGaer"
};
const statusConfig: Record<SessionStatusBadgeStatus, {
  message: MessageDescriptor;
}> = {
  'needs-input': {
    message: messages.needsInput
  }
};
export const SessionStatusBadge = ({
  status,
  iconSize = 12,
  testId = 'session-status-badge',
  ariaLabel
}: SessionStatusBadgeProps): React.JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  const {
    message
  } = statusConfig[status];
  const label = formatMessage(message);
  return <Inline as="span" alignBlock="center" space="space.025" shouldWrap={false} xcss={cx(styles.badge, statusStyles[status])} testId={testId} aria-label={ariaLabel}>
			<SessionStatusIcon status={status} iconSize={iconSize} appearance="outlined" />
			<Box as="span" xcss={styles.label}>
				<Text as="span" color="inherit" size="small" weight="medium">
					{label}
				</Text>
			</Box>
		</Inline>;
};